export default "__VITE_ASSET__kg6Ztmi6__"